import { matchVersion } from '../../utils';
import __regexp from './__edge-regexp';
/** Detect Microsoft Edge Browser version */
export default function isEdgeVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 2
		});
	};
}
